import { motion } from 'framer-motion';
import styled from 'styled-components';

const Navigation = styled.div`
  min-height: calc(100vh - 60px);
  width: ${({ open }) => (open ? '300px' : '64px')};
  min-width: ${({ open }) => (open ? '300px' : '60px')};
  transition: width 0.1s ease-in-out;
  display: ${({ open, $showSideNav }) =>
    open || $showSideNav ? 'flex' : 'none'};
  flex-direction: column;
  box-shadow: 1px 0 5px -2px ${({ theme }) => theme.COLOR_GREY};
  position: ${({ open }) => (open ? 'absolute' : 'relative')};
  z-index: 12;
  background-color: ${({ theme }) =>
    theme.COLOR_SECONDARY ?? theme.COLOR_BLACK};
  @media (max-width: 768px) {
    width: ${({ open }) => (open ? '100%' : '5%')};
  }
`;

const NavItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-top: 10px;
  height: 40px;
  overflow: hidden;
  min-width: 60px;
  &.logout {
    flex-grow: 1;
    justify-content: flex-end;
    height: unset;
  }
  &.child {
    margin-top: 1px;
  }
  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
  a {
    text-transform: capitalize;
    padding: ${(props) => (props.open ? '12px 12px 12px 22px' : '12px')};
    color: ${({ theme }) => theme.COLOR_TEXT};
    text-decoration: none;
    transition: 0.3s linear;
    border-radius: ${(props) => (props.open ? '0' : '8px')};
    display: flex;
    height: 100%;
    width: ${(props) => (props.open ? '100%' : '40px')};
    justify-content: ${(props) => (props.open ? 'start' : 'center')};
    margin: ${(props) => (props.open ? '0' : '0px auto')};
    white-space: nowrap;
    position: relative;
    svg {
      margin-right: ${(props) => (props.open ? '15px' : '0')};
    }
    @media (max-width: 768px) {
      font-size: 12px;
      text-align: left;
    }
    &.child {
      background-color: ${({ theme }) => theme.COLOR_BLACK};
      margin-left: 40px;
    }
    @media (hover: hover) {
      &:hover {
        color: ${({ theme }) => theme.COLOR_WHITE};
      }
    }
    &.active {
      color: ${({ theme }) => theme.COLOR_WHITE};
      &::after {
        content: '';
        position: absolute;
        width: 8px;
        height: 24px;
        background-color: ${({ theme }) => theme.COLOR_PRIMARY};
        left: -12px;
      }
    }
    &.activeChild {
      font-weight: 600;
      background-color: ${({ theme }) => theme.COLOR_BLACK};
    }
    transition: 0.1s all ease-in-out;
  }
  display: ${(props) => props.hidden && 'none'};
`;

const DropDown = styled.div`
  width: 100%;
  margin-top: 10px;
  background-color: inherit;
`;

const DropDownHeader = styled.div`
  padding: 12px 12px 12px 22px;
  font-size: 16px;
  color: ${({ theme }) => theme.COLOR_GREY4};
  font-weight: 400;
  margin: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: start;
  position: relative;
  span {
    color: ${({ theme }) => theme.COLOR_TEXT};
    margin-left: 37px;
  }
  &.active {
    color: ${({ theme }) => theme.COLOR_WHITE};
  }
  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.COLOR_WHITE};
    }
  }
  .icon {
    margin-right: 15px;
    position: absolute;
    left: 22px;
  }
  .exp {
    position: absolute;
    right: 11px;
  }
`;

const DropDownBody = styled(motion.div)`
  overflow: hidden;
`;

const DropDownChildren = styled(motion.div)`
  max-height: ${(props) => (props.maxHeight ? props.maxHeight : 'unset')};
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background: white;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.2);
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 5px;
  }
  scrollbar-face-color: rgba(0, 0, 0, 0.3); /* Firefox 63 compatibility */
  scrollbar-track-color: rgba(0, 0, 0, 0.2); /* Firefox 63 compatibility */
  scrollbar-color: rgba(0, 0, 0, 0.3) rgba(0, 0, 0, 0.2);
  scrollbar-width: thin;
`;

const Version = styled.div`
  color: grey;
  text-align: right;
  font-size: 12px;
  padding: 0 5px;
  width: 100%;
`;

const StyledNavigation = {
  Navigation,
  NavItem,
  DropDown,
  DropDownHeader,
  DropDownBody,
  DropDownChildren,
  Version,
};

export default StyledNavigation;
